const topics = [
  { label: '韩漫推荐', heat: '128万讨论', icon: 'ri-fire-line', color: 'bg-primary-100/70 text-primary-700' },
  { label: '国漫崛起', heat: '96万讨论', icon: 'ri-flag-line', color: 'bg-accent-100/70 text-accent-700' },
  { label: '日漫经典', heat: '215万讨论', icon: 'ri-sun-line', color: 'bg-secondary-100/70 text-secondary-700' },
  { label: '穿越题材', heat: '87万讨论', icon: 'ri-rocket-line', color: 'bg-primary-100/70 text-primary-700' },
  { label: '系统流', heat: '64万讨论', icon: 'ri-computer-line', color: 'bg-accent-100/70 text-accent-700' },
  { label: '热血少年', heat: '152万讨论', icon: 'ri-heart-pulse-line', color: 'bg-secondary-100/70 text-secondary-700' },
  { label: '恋爱甜宠', heat: '103万讨论', icon: 'ri-heart-line', color: 'bg-primary-100/70 text-primary-700' },
  { label: '悬疑烧脑', heat: '58万讨论', icon: 'ri-lightbulb-line', color: 'bg-accent-100/70 text-accent-700' },
  { label: '完结精品', heat: '176万讨论', icon: 'ri-check-double-line', color: 'bg-secondary-100/70 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-2">看看大家都在讨论什么，找到你的同好圈</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className={`flex items-center gap-2.5 px-5 py-3 rounded-full ${topic.color} cursor-pointer hover:scale-105 transition-transform duration-200`}
            >
              <i className={`${topic.icon} text-sm`}></i>
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-[10px] opacity-60 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}